// extracted by mini-css-extract-plugin
export default {"background":"Preloader_background__Aqj7M","roller":"Preloader_roller__Xrq9W","lds-roller":"Preloader_lds-roller__+gwkt"};